import { OCCASION_CONFIG, TEMPLATE_CONFIG } from "@listou/shared/constants";
import { ADMIN_LIST_SORTS, type AdminListSort } from "@listou/shared/schemas/admin";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

import { Box, Pending, Table } from "../components/admin/retro";
import { adminListsQuery } from "../lib/queries";

export const Route = createFileRoute("/_authed/admin/listes")({
  component: ListsPage,
});

const SORT_LABELS: Record<AdminListSort, string> = {
  recent: "récentes",
  wishes: "envies",
  reserved: "réservés",
  clicks: "clics",
};

function ListsPage() {
  const [sort, setSort] = useState<AdminListSort>("recent");
  const lists = useQuery(adminListsQuery(sort));
  return (
    <Box
      title="listes"
      right={
        <span className="inline-flex gap-1">
          {ADMIN_LIST_SORTS.map((option) => (
            <button
              key={option}
              type="button"
              className="retro-btn"
              aria-pressed={sort === option}
              onClick={() => setSort(option)}
            >
              {SORT_LABELS[option]}
            </button>
          ))}
        </span>
      }
    >
      {lists.data ? (
        <div className={lists.isPlaceholderData ? "opacity-60" : undefined}>
          <Table
            head={[
              "liste",
              "occasion",
              "modèle",
              "visibilité",
              "créée",
              "date",
              "membres",
              "envies (qté)",
              "réservés",
              "clics",
            ]}
            rows={lists.data.lists.map((list) => [
              {
                value: (
                  <a
                    href={`/l/${list.slug}`}
                    target="_blank"
                    rel="noreferrer"
                    className="hover:underline"
                  >
                    {list.archived ? "† " : ""}
                    {list.title}
                  </a>
                ),
                num: false,
                tone: list.archived ? "dim" : undefined,
                title: list.title,
              },
              { value: OCCASION_CONFIG[list.occasion].label, num: false },
              { value: TEMPLATE_CONFIG[list.template].label, num: false },
              { value: list.visibility, num: false },
              list.createdAt.slice(0, 10),
              list.eventDate ?? "-",
              list.memberCount,
              `${list.wishCount} (${list.wishQuantity})`,
              list.reservedQuantity === null
                ? { value: "surprise", tone: "dim" }
                : `${list.reservedQuantity} / ${list.wishQuantity}`,
              list.clickCount,
            ])}
          />
        </div>
      ) : (
        <Pending query={lists} />
      )}
    </Box>
  );
}
